import { createGlobalStyle, keyframes } from 'styled-components';
import { theme } from './theme';
import { fadeInLeft, fadeInDown, fadeInRight } from 'react-animations';

const fadeInLeftAnimation = keyframes`${fadeInLeft}`;
const fadeInDownAnimation = keyframes`${fadeInDown}`;
const fadeInRightAnimation = keyframes`${fadeInRight}`;

const GlobalStyle = createGlobalStyle`
/* font samim*/
@font-face {
  font-family: 'samim';
  src: url('/assets/fonts/Samim-FD.woff2') format('woff2'),
       url('/assets/fonts/Samim-FD.woff') format('woff'),
       url('/assets/fonts/Samim-FD.ttf') format('truetype');
  font-weight: normal;
}

@font-face {
  font-family: 'samim';
  src: url('/assets/fonts/Samim-Bold-FD.woff2') format('woff2'),
       url('/assets/fonts/Samim-Bold-FD.woff') format('woff'),
       url('/assets/fonts/Samim-Bold-FD.ttf') format('truetype');
  font-weight: bold;
}
@font-face {
    font-family: "SamimEn";
    src: url("/assets/fonts/Samim.woff") format("woff");
    font-weight: normal;
    font-style: normal;
  }
  *{
    font-family: 'samim';
  }
body,html{
  /* overflow-x:scroll; */
  font-family:'samim';
  padding-right: 0!important;
  padding-left: 0!important;
  margin: 0;
  font-size: 14px;
  height:100%;
  direction:rtl;
  scroll-behavior: smooth;
  background-color: #fcfcfc;
}
div, p, span {
    user-select: none;
}
  header#header {
    border-radius: 0 0 35px 35px;
    min-height: 120px;
    max-height: 243px;
    background-color: ${theme.primaryColor};
  }
ul{
  padding: 0;
  margin: 0;
  li{
    list-style-type: none;
  }
}
/* global classes */
.preLineSpace{
  white-space:pre-line;
}
.rtl{
  direction: rtl !important;
}
.ltr{
  direction: ltr !important;
}
/* tags css config */
h1,h2,h3,h4,h5,h6{
    font-weight: bold;
    color: ${theme.dark};
}
a{
  color: ${theme.gray};
  text-decoration:none;
  display:block;
}
p,label{
  color:${theme.gray};
  font-size:1rem;
}
img{
  width: 100%;
  height: auto;
  &.image {
    min-width: 260px;
    min-height: 169px;
    background: url("/assets/images/default-image.svg");
    background-size: 50%;
    background-position: 50%;
    background-repeat: no-repeat;
    max-width:450px;
  }
  &.defaultbackground{
    background: url("/assets/images/default-image.svg");
    background-size: 50%;
    background-position: 50%;
    background-repeat: no-repeat;
  }
  &.ico{
    width:25px;
    height:auto;
    padding: 3px;
  }
}
.DatePicker {
    width: 100% !important;
}
input{
  &.form-control{
    border-radius:10px;
  }
  &[type=text],&[type=number]{
  width:100%;  
  }
  display: block;
  &::placeholder{
    opacity:.5 !important; 
  }
 /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type=number] {
    -moz-appearance: textfield;
  }
}
  .parentInputIcon{
    .inputIcon{ 
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
      left: 5%;
      z-index: 9;
    }
    position: relative;
    .svgIconDown{ 
      width: 2rem;
      height: 2rem;
      fill: #11C84F;
      transition: transform .2s ease-in-out;
    }
    &:not(.collapsed){
      .svgIconDown{
          transform: rotateX(180deg);
        }
    }
  }
/* --- colors ----- */
.bg{
  &Primary{
    background-color: ${theme.primaryColor};
    color: ${theme.white};
  }
  &LightPrimary{
    background-color: ${theme.lightPrimary};
    color: ${theme.gray};
  }
  &-white{
      background-color:rgb(255, 255, 255);
  }
  &-light{
    background-color: ${theme.light};
  }
  &-orange{
    background-color: ${theme.orange};
  }
  &-carnation {
    background-color: ${theme.carnation};
  }
  &-purple{
    background-color: ${theme.purple};
  }
  &-blue{
    background-color: ${theme.blue} ;
  }
  &-gray{
    background-color: ${theme.gray} ;
  }
}
.text{
  &Primary{
    color: ${theme.primaryColor};
  }
  &-gray{
    color: ${theme.gray};
  }
}
/* alignment  */
.text{
  &-nowrap{
    overflow: hidden!important;
    text-overflow: ellipsis;
  }
}
.fs-{
  &10{
    font-size:10px;
  }
  &12{
    font-size:12px;
  }
  &14{
    font-size:14px;
  }
  &16{
    font-size:16px;
  }
  &18{
    font-size:18px;
  }
}
/* flex */
    .flex-{
        &auto{
          flex:auto;
        }
    }
/* gradiant */
.gradiantPrimary{
    background-image: linear-gradient( to top  , ${'#1ACC56'} , ${theme.lightPrimary} );
}
/* buttons styles */
.btn{
  border-radius:12px;
  min-width:80px;
  border: solid 2px #11c84f;
  &Primary{
      background-color: ${theme.primaryColor};
      color: ${theme.white};
      &:hover,&:focus{
      color: ${theme.white};
      background-color: ${theme.gray};
    }
  }
  &Light{
    background-color: ${theme.white};
    color: ${theme.primaryColor};
    border: solid 2px ${theme.primaryColor};
    &:hover{
      color: ${theme.white};
      background-color: ${theme.gray};
    }
  }
}
/* border-style */
.borderPrimary{
    border: solid 2px ${theme.primaryColor};
}
/* raduis classes */
.rad-10 {
    border-radius: 10px;
}
.rad-12{
    border-radius: 12px !important;
}
.rad-t-12{
    border-top-left-radius: 12px !important;
    border-top-right-radius: 12px !important;
}
.rad-15{
    border-radius: 15px !important;
}
.rad-b-15{
    border-bottom-left-radius: 15px !important;
    border-bottom-right-radius: 15px !important;
  }
.rad-t-15{
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
}
.rad-r-15{
    border-top-right-radius: 15px !important;
    border-bottom-right-radius: 15px !important;
}
.rad-l-15{
    border-top-left-radius: 15px !important;
    border-bottom-left-radius: 15px !important;
}
.rad-25{
    border-radius: 25px !important;
}
.rad-100{
    border-radius: 100% !important;
}
.rad-b-35{
    border-radius: 0 0 35px 35px;
}
/* shadows style */
.box-shadow{
    box-shadow:0 0 5px 5px rgba(199, 199, 199, 0.2) !important;
}
.light-shadow {
  box-shadow: 0 0 15px 1px rgb(0 0 0 / 10%);
}
/* cursor */
.cursor-pointer{
  cursor:pointer;
}
/* listItemIcons */
  .listItemIcons {
    position: relative;
    border-radius: 15px;
    min-width: 50px;
    width: 50px;
    height: 50px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: linear-gradient( to top  ,  #1ACC56, #82FFAD);
    box-shadow:0 6px 6px 0 rgba(17, 200, 78, 0.15);
    &.smallCircle{
      img{
        width: 30px;
      }
      border-radius: 50%;
      @media (min-width:340px) {
        min-width: 45px;
        min-height: 45px;
        width: 45px;
        height: 45px;
      }
    }
   > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-size: 2.2rem;
    color: ${theme.white};
    text-align: center;
  }
  img{
    width: 30px;
  }
}
.circle{
    position: relative;
    background-size: 45%;
    background-position: center;
    background-repeat: no-repeat;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin: 0 auto;
    color: rgb(17, 200, 79);
    >img{
      position: absolute;
      top: 50%;
      left: 50%;
      width:30px;
      height:30px;
      transform: translate(-50%,-50%);
  }
}
/* plus icon for add */
.addIcon{
    position: fixed;
    width:45px;
    height:45px;
    bottom: 70px;
    left: 25px;
    .btn{
        background-image: linear-gradient( to top  ,  #1ACC56, #82FFAD);
        color: ${theme.white};
        border: none;
        max-width:45px;
        max-height:45px;
        min-width:45px;
        min-height:45px;
    }
}
/* center  elements */
.centeredContent{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
/* app toolbar */
.app-toolbar {
    position: sticky;
    top: 0;
    z-index: 103;
}
/* width and height globaly */
.min-{
  &height-250{
    min-height:250px;
  }
}
.position-b-80{
  position: relative;
  bottom: 80px;
}

  /* ----------------- */
  /* -- global codes is here -- */
  /* ----------------- */

 /***--- login and splash page ---- */
  .welcomeBackground{
    background: url("/assets/images/splash-back.png");
    background-size: 100%;
    min-height: 40vh;
    background-repeat: no-repeat;
    border-radius: 0 0 20px 20px;
    position: relative;
}
/* ripple */
.ripple {
	display: inline-block;
	position: relative;
	overflow: hidden;
	transition: all ease-in-out .5s;
}

.ripple::after {
	content: "";
	display: block;
	position: absolute;
	top: 0;
	left: 25%;
	height: 100%;
	width: 50%;
	background-color: #000;
	border-radius: 50%;
	opacity: 0;
	pointer-events: none;
	transition: all ease-in-out 0.7s;
	transform: scale(10, 10);
}
.ripple:active::after {
	padding: 0;
	margin: 0;
	opacity: .2;
	transition: 0s;
	transform: scale(0, 0);
}
/* material Ui global style */
.MuiTabs{
    &-flexContainer{
        justify-content: space-around !important;
}
    &-indicator{
        background: #11C84F !important;
        bottom: 0 !important;
        border-radius: 2px !important;
        height:3px !important;
    }
}
.Mui-selected {
    font-weight:bold !important;
    color: #fff;
    background: #11c84f;
}
/* wallet modal */
@media (max-width: 450px){
  .rmdp-wrapper .rmdp-day, .rmdp-week-day {
      height: 30px;
      width: 30px;
  }
}
/* end wallet */
.noClick {
   pointer-events: none;
}
/* fade animations */
.fadeIn{
        &Left{
          animation: 0.4s ${fadeInLeftAnimation};
        }
        &Down{
          animation: 0.4s ${fadeInDownAnimation};
        }
        &Right{
          animation: 0.4s ${fadeInRightAnimation};
        }
  }
`;

export default GlobalStyle;
